import styled from 'styled-components';
import {hexToRGBA} from "../social-profile/social-profile.style";

export const ClapTip = styled.div`
  @keyframes fadeUp {
    100% {
      transform: translate3d(-50%, -50%, 0);
    }
  }

  animation: fadeUp 1s;
  animation-fill-mode: forwards;
  position: absolute;
  background-color: ${({theme}) => theme.semiforeground};
  box-shadow: 0 4px 15px ${({theme}) => hexToRGBA(theme.text, 0.3)};
  pointer-events: none;
  padding: 0.4rem 0.8rem;
  border-radius: 3px;
  color: ${({theme}) => theme.body};
  bottom: 90%;
  left: 0.4rem;
  //opacity: 0;
  white-space: nowrap;
  //visibility: hidden;
  z-index: 999;
  transform: translate3d(-50%, 0, 0);
  transition: 0.35s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid ${({theme}) => theme.semiforeground};
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
  }
`;


export const StyledPostMeta = styled.div`
  bottom: 0;
  user-select: none;
  font-size: 18px;

  span.num {
    // Prevents things from moving when number increments
    display: inline-block;
    width: 0;
  }
    
  .confetti-origin {
    position: relative;
  }

  .can-clap {
    cursor: pointer;

    &.enlarge-hands {
      @keyframes clapHands {
        33% {
          transform: rotate(-20deg) scale(1);
        }
        67% {
          transform: rotate(20deg) scale(1.2);
        }
      }
      animation: clapHands 0.5s ease-in-out;
    }
  }

  &.item-meta {
    position: absolute;
    width: 100%;
    bottom: calc(1em - 1px);
    font-size: 15px;
    div.bottom-meta {
      display: grid;
      grid-template-columns: repeat(8, 1fr);

      @media (max-width: 720px) {
        grid-template-columns: repeat(6, 1fr);
      }
      @media (max-width: 512px) {
        grid-template-columns: repeat(5, 1fr);
      }
      @media (max-width: 360px) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    .tag-component{
        transform: translateY(-.25em);
    }
    @media (max-width: 512px) {
      .tag-component {
        display: none;
      }

      @media (max-width: 360px) {
        .date {
          display: none;
        }
      }
        
      @media (max-width: 300px) {
          .minutes {
              display: none;
          }
      }
    }
  }

  &.post-meta {
    font-size: 15px;
    @media (max-width: 400px) {
        font-size: 13px;
    }  
      
    div.top-meta {
      margin-bottom: 1em;
    }

    div.bottom-meta {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
    }

    @media (max-width: 720px) {
        @media (min-width: 501px) {
          .minutes {
            display: none;
          }
        }
    }
      @media (max-width: 320px) {
        .minutes {
          display: none;
        }
      }
  }


  
  svg {
    margin-right: .5em;
    transform: translateY(.1em);
  }


  color: ${({theme}) => theme.text};

  // .tag {
  //   font-size: 15px;
  //   //color: #2251ff;
  //   color: ${({ theme }) => theme.body};
  //   background-color: ${({ theme }) => theme.text};
  //   border-radius: 6px;
  //   padding: 4px 4px 4px 10px;
  //   width: fit-content;
  //   margin: 0 4px 0 4px;
  // }
`;
